import { render, staticRenderFns } from "./EditOptionsQuestionComponent.vue?vue&type=template&id=3240700a&"
import script from "./EditOptionsQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./EditOptionsQuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditOptionsQuestionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports